import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Row, Col, Table, Button, Form } from "react-bootstrap";
import { fetchApprovals } from "../../store/actions/timesheet/approvalsActions";
import { resetTimesheet } from "../../store/actions/timesheet/timesheetActions";
import { Cache } from "aws-amplify";
import {
  MANAGER,
  PROJECT_SPONSOR,
  TEAM_LEADER,
} from "../../store/actions/users/usersActions";
import { togglePrompt } from "../../store/actions/commonActions";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckDouble,
  faBan,
} from "@fortawesome/free-solid-svg-icons";

import TimesheetConfirmations from "./TimesheetConfirmations";

class TimesheetApprovals extends Component {
  componentDidMount() {
    const roleId = Cache.getItem("roleId");

    if (
      roleId === MANAGER ||
      roleId === TEAM_LEADER ||
      roleId === PROJECT_SPONSOR
    ) {
      this.props.fetchApprovals();
    } else {
      this.props.history.push("/approvals");
    }

    this.timesheetIds = [];
    this.requestIds = [];
    this.hasChecked = false;
  }

  enableApproveSelected = () => {
    const approveSelected = document.getElementById("approveSelected");
    if (approveSelected) {
      approveSelected.disabled = !Array.from(
        document.querySelectorAll(".thisCheckbox input[type='checkbox']")
      ).filter((box) => box.checked).length;
    }
  };

  renderApprovals = () => {
    let approvals = this.props.approvals.approvals;
    let approvalsList = "";
    let requestId = "";
    let approveSelectedButton = "";

    if (approvals && approvals.length) {
      approvalsList =
        approvals.length > 0 ? (
          approvals.map((approval, key) => {
            let firstName = "";
            let lastName = "";
            let middleName = "";
            let fullName = "";
            let missing_hours = 0;
            let overtime_hours = 0;

            let timesheetId = approval.timesheet_id;

            if (timesheetId) {
              requestId =
                "TSR" +
                moment(approval.start_date).format("YYYYMM") +
                timesheetId.toString().padStart(6, "0");
            }

            let approvalCheckbox = (
              <>
                <td className="approvalCheckbox">
                  <Form.Check
                    timesheetid={timesheetId}
                    requestid={requestId}
                    className="thisCheckbox"
                    type="checkbox"
                    onClick={(e) => {
                      this.enableApproveSelected();
                      document.querySelector(
                        '.checkAll input[type="checkbox"]'
                      ).checked = false;
                    }}
                  />
                </td>
              </>
            );

            if (typeof approval.requestor_details !== "undefined") {
              const requestor = approval.requestor_details;

              if (requestor) {
                if (requestor.first_name) {
                  firstName = requestor.first_name;
                }

                if (requestor.last_name) {
                  lastName = requestor.last_name;
                }

                if (requestor.middle_name) {
                  middleName = requestor.middle_name;
                }

                fullName = lastName + ", " + firstName + " " + middleName;

                missing_hours = approval.total_missing_hours;
                overtime_hours = approval.total_overtime_hours;

                if (missing_hours) {
                  const approveButton = document.getElementById(
                    "approveButton" + timesheetId
                  );
                  if (approveButton) {
                    approveButton.disabled = true;
                    approvalCheckbox = (
                      <>
                        <td className="approvalCheckbox">
                          <Form.Check disabled="disabled" />
                        </td>
                      </>
                    );
                  }
                }
              }
            }

            return (
              <tr key={key} id={"timesheetId" + timesheetId}>
                {approvalCheckbox}
                <td>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();

                      this.props.resetTimesheet();
                      this.props.history.push(
                        "/timesheet/approval?id=" + timesheetId
                      );
                    }}
                  >
                    {requestId}
                  </Link>
                </td>
                <td>{fullName}</td>
                <td>{approval.start_date}</td>
                <td>{approval.end_date}</td>
                <td>{missing_hours}</td>
                <td>{overtime_hours}</td>
                <td>
                  <Button
                    size="sm"
                    className="mr-1 float-right btn-primary"
                    timesheetId={timesheetId}
                    requestId={requestId}
                    id={"approveButton" + timesheetId}
                    onClick={(e) => {
                      this.confirmAction = "APPROVE_TIMESHEET";
                      this.timesheetId = e.target.getAttribute("timesheetId");
                      this.requestId = e.target.getAttribute("requestId");
                      this.props.togglePrompt(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faCheck} /> Approve
                  </Button>

                  <Button
                    size="sm"
                    className="mr-1 float-right btn-primary"
                    timesheetId={timesheetId}
                    requestId={requestId}
                    id={"rejectButton" + timesheetId}
                    onClick={(e) => {
                      this.confirmAction = "REJECT_TIMESHEET";
                      this.timesheetId = e.target.getAttribute("timesheetId");
                      this.requestId = e.target.getAttribute("requestId");
                      this.props.togglePrompt(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faBan} /> Reject
                  </Button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={7}>
              <p className="text-danger">No approvals found.</p>
            </td>
          </tr>
        );
      approveSelectedButton = (
        <Button
          size="sm"
          id="approveSelected"
          className="float-right mb-3 btn-primary"
          onClick={() => {
            const boxen = Array.from(
              document.querySelectorAll(".thisCheckbox input[type='checkbox']")
            ).filter((box) => box.checked);
            this.timesheetIds = boxen.map((box) =>
              box.getAttribute("timesheetid")
            );
            this.requestIds = boxen.map((box) => box.getAttribute("requestid"));
            this.confirmAction = "APPROVE_SELECTED_TIMESHEETS";
            this.props.togglePrompt(true);
          }}
        >
          <FontAwesomeIcon icon={faCheckDouble} /> Approve Selected
        </Button>
      );
    } else {
      approvalsList = (
        <tr>
          <td colSpan={4}>
            <p className="text-danger">No approvals found.</p>
          </td>
        </tr>
      );
    }

    this.enableApproveSelected();

    return (
      <>
        <TimesheetConfirmations
          confirmAction={this.confirmAction}
          timesheetid={this.timesheetId}
          requestid={this.requestId}
          timesheetids={this.timesheetIds}
          requestids={this.requestIds}
          inDashboard={this.props.inDashboard}
        />
        {approveSelectedButton}
        <Table hover>
          <thead>
            <tr>
              <th className="approvalCheckbox">
                <Form.Check
                  className="checkAll"
                  type="checkbox"
                  onClick={(e) => {
                    document
                      .querySelectorAll(".thisCheckbox input[type='checkbox']")
                      .forEach((box) => {
                        box.checked = e.target.checked;
                      });
                    document.getElementById("approveSelected").disabled =
                      !e.target.checked;
                  }}
                />
              </th>
              <th>Request ID</th>
              <th>Requestor Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Missing Hours</th>
              <th>Overtime Hours</th>
              <th width="15%"></th>
            </tr>
          </thead>
          <tbody>{approvalsList}</tbody>
        </Table>
      </>
    );

    /*
      <th>
        <Button size="sm" className="mr-1 confirmSelection" variant="danger" disabled="disabled" onClick={() => {
          this.confirmAction = 'REJECT_SELECTED_TIMESHEETS';
          this.props.togglePrompt(true);
        }}>Reject Selected</Button>
      </th>
    */
  };

  render() {
    let heading = (
      <>
        <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Timesheets</h6>
          </Col>
        </Row>
      </>
    );
    if (this.props.inDashboard) {
      heading = "";
    }

    return (
      <React.Fragment>
        {heading}
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {this.renderApprovals()}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  approvals: state.approvals,
  projects: state.projects,
});

const mapStateToDispatch = (dispatch) => {
  return {
    fetchApprovals: () => dispatch(fetchApprovals()),
    resetTimesheet: () => dispatch(resetTimesheet()),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapStateToDispatch)(TimesheetApprovals)
);
